import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guard/auth.guard';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'about',
        loadChildren: () =>
          import('@features/about/about.module').then((m) => m.AboutModule),
      },
      {
        path: 'product',
        loadChildren: () =>
          import('@features/product/product.module').then(
            (m) => m.ProductModule
          ),
      },
      {
        path: 'cart',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@features/cart/cart.module').then((m) => m.CartModule),
      },
      {
        path: 'checkout',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@features/checkout/checkout.module').then(
            (m) => m.CheckoutModule
          ),
      },
      {
        path: 'user',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@features/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'notification',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@features/notification/notification.module').then(
            (m) => m.NotificationModule
          ),
      },
      {
        path: 'term-condition',
        loadChildren: () =>
          import('@features/term-condition/term-condition.module').then(
            (m) => m.TermConditionModule
          ),
      },
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('@features/privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'beautybook',
        loadChildren: () =>
          import('@features/beautybook/beautybook.module').then(
            (m) => m.BeautybookModule
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('@features/faq/faq.module').then(
            (m) => m.FaqModule
          ),
      },
      {
        path: 'user-skinfit-nologin',
        loadChildren: () =>
          import('@features/user/pages/user-skin-fit/user-skin-fit-nologin/user-skin-fit-nologin.module').then(
            (m) => m.UserSkinFitNologinModule
          ),
      },
      {
        path: 'shop/:slug',
        loadChildren: () =>
          import('@features/shop/shop.module').then((m) => m.ShopModule),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
